import { useId, type FC, type ReactNode } from 'react';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './LinkColumn.scss';

type Props = {
    title: ReactNode;
    children: ReactNode;
};

const LinkColumn: FC<Props> = ({ title, children }) => {
    const labelId = `${useId()}-label`;

    return (
        <div className={classnames(styles.column, dibsCss.flex, dibsCss.flexCol)}>
            <div
                id={labelId}
                className={classnames(
                    dibsCss.sassyFontSubHeader,
                    dibsCss.m0,
                    dibsCss.mbSmall,
                    dibsCss.textPitchblack
                )}
            >
                {title}
            </div>
            <ul
                aria-labelledby={labelId}
                className={classnames(styles.list, dibsCss.m0, dibsCss.p0)}
            >
                {children}
            </ul>
        </div>
    );
};

export default LinkColumn;
